module.exports = __webpack_public_path__ + "23.ad877d44.png";